import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
/* eslint-disable */

import * as React from 'react';
import MediaQuery from 'react-responsive';
import classnames from 'classnames';
import { Analytics, AnalyticsContext, AnalyticsLocationProvider, AnalyticsLocationConsumer, trackEvent } from 'latitude-analytics';
import { ANALYTICS } from '@latitude/core/utils/constants';
import HamburgerButton from './HamburgerButton';
import MenuItem from './MenuItem';
import TopMenuItem from './TopMenuItem';
import LogonButton from './LogonButton';
import LoginForm from './LoginForm';
import { LoginModal, getLoginModalData } from './LoginModal';
import SearchButton from './SearchButton';
import SearchForm from './SearchForm';
import { DESKTOP_CUTOFF_POINT, MOBILE_CUTOFF_POINT } from './BaseHeader.constant';
import { toggleBodyScrolling } from './BaseHeader.utils';
import './_base-header.scss';
/**
 * Custom types
 */

/**
 * This serves as a base header component that can serve multiple sites via:
 * - passed in navigation data
 * - passed in brand button content (logo)
 * - passed in marketing banners in mega menus
 */

var BaseHeader = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BaseHeader, _React$Component); // DOM ref elements
  // These HTML elements are used to exclude clicking on their corresponding elements from popup closing logic.
  // E.g. We close a Login dialog when a user clicks outside of it UNLESS the click was on Login button.
  // To do that we pass a Ref to the Login button into the Login component.
  // We do the same with the mega menu popup.
  // HTML element of the hamburger button
  // HTML element of the Logon button
  // HTML element of the top navigation bar


  function BaseHeader(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // element refs

    _this.state = {
      isNavOpen: false,
      isSearchOpen: false,
      animateClose: false,
      isLoginOpen: false,
      isNavBackgroundVisible: false,
      activeMenuId: null,
      loginModalData: null,
      showLoginModal: false
    };

    _this.handleKeyDown = function (event) {
      // Close the popup on Esc key
      if (event.keyCode === 27) {
        _this.closeActiveMenu();
      }
    };

    _this.handleClick = function (ev) {
      var clickTarget = ev.target instanceof Node ? ev.target : null; // if we click outside the menu, close it

      if (_this.hamburgerButton && !_this.hamburgerButton.contains(clickTarget) && _this.topMenuItems && !_this.topMenuItems.contains(clickTarget)) {
        _this.closeActiveMenu();
      }
    };

    _this.closeActiveMenu = function () {
      _this.setState({
        isNavOpen: false,
        activeMenuId: null
      });
    };

    _this.handleMenuItemClick = function (menuItem, analytics, location) {
      var isActive = _this.state.activeMenuId === menuItem.id;

      var getActionLabel = function getActionLabel() {
        var href = menuItem.href;

        if (href === undefined) {
          return 'interaction';
        }

        if (href.startsWith('http')) {
          return 'external-link';
        }

        return 'internal-link';
      };

      _this.setState(function (state) {
        return Object.assign({}, state, {
          activeMenuId: isActive ? null : menuItem.id
        });
      }, function () {
        if (!isActive) {
          trackEvent(analytics, {
            category: menuItem.href !== undefined ? 'text-link' : 'megamenu',
            action: getActionLabel(),
            label: menuItem.label,
            location: location
          });
        }
      });
    };

    _this.toggleNavOpen = function (analytics, location) {
      /**
       * Hamburger button event tracking
       */
      if (trackEvent) {
        trackEvent(analytics, {
          category: 'nav',
          action: 'interaction',
          label: 'open',
          location: location
        });
      }

      toggleBodyScrolling(_this.state.isNavOpen);

      _this.setState(function (state) {
        return {
          isNavOpen: !state.isNavOpen,
          activeMenuId: null,
          isLoginOpen: false,
          isSearchOpen: false
        };
      });
    };

    _this.closeSearchForm = function () {
      // animate the search input closing
      _this.setState({
        animateClose: true
      }); // wait for the `close animation` to finish before updating state


      setTimeout(function () {
        toggleBodyScrolling(true);

        _this.setState({
          isSearchOpen: false
        });
      }, 600);
    };

    _this.toggleSearchIsActive = function () {
      _this.setState(function (state) {
        return Object.assign({}, state, {
          isLoginOpen: false,
          animateClose: false,
          isSearchOpen: !state.isSearchOpen
        });
      });
    };

    _this.closeLoginForm = function () {
      return _this.setState({
        isLoginOpen: false
      });
    };

    _this.toggleLoginIsActive = function (analytics, location) {
      _this.setState(function (state) {
        return Object.assign({}, state, {
          isNavOpen: false,
          isLoginOpen: !state.isLoginOpen
        });
      }, // callback
      function () {
        _this.closeSearchForm();
      });
    };

    _this.closeLoginModal = function () {
      return _this.setState({
        showLoginModal: false
      });
    };

    _this.renderMainMenu = function (isVisible, analytics, location) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          _this.topMenuItems = el;
        },
        className: classnames('top-menu-items', {
          'is-open': _this.state.isNavOpen,
          'is-visible': isVisible
        })
      }, _this.props.navTreeData.items.map(function (menuItem) {
        var isActive = _this.state.activeMenuId === menuItem.id;
        return /*#__PURE__*/React.createElement(TopMenuItem, Object.assign({
          key: menuItem.id
        }, menuItem, {
          active: isActive,
          onClick: function onClick() {
            _this.handleMenuItemClick(menuItem, analytics, location);
          }
        }), _this.renderSubMenu(menuItem.id, analytics, location));
      }), /*#__PURE__*/React.createElement(MediaQuery, {
        maxWidth: MOBILE_CUTOFF_POINT
      }, _this.renderMobilePane(analytics, location))), /*#__PURE__*/React.createElement(MediaQuery, {
        maxWidth: MOBILE_CUTOFF_POINT
      }, /*#__PURE__*/React.createElement("div", {
        className: "top-menu-items__overlay"
      })));
    };

    _this.renderSubMenu = function (menuId, analytics, location) {
      var menu = _this.props.navTreeData.items.find(function (item) {
        return item.id === menuId;
      });

      if (!menu) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "menu-items"
      }, [0, 1, 2].map(function (columnIndex) {
        // If we have menu items in this column, render them
        if (menu.items && menu.items.length > columnIndex) {
          var column = menu.items[columnIndex];
          return /*#__PURE__*/React.createElement("div", {
            key: columnIndex,
            className: "menu-items__group"
          }, column.map(function (menuItem) {
            return /*#__PURE__*/React.createElement(MenuItem, Object.assign({
              key: menuItem.id
            }, menuItem, {
              indentLeftMobile: !menuItem.labelOnly,
              active: _this.state.activeMenuId === menuItem.id,
              onClick: function onClick() {
                return _this.handleMenuItemClick(menuItem, analytics, location);
              },
              desktopOnly: menuItem.desktopOnly,
              mobileOnly: menuItem.mobileOnly
            }));
          }), columnIndex === 2 && menu.banner && /*#__PURE__*/React.createElement(MediaQuery, {
            minWidth: DESKTOP_CUTOFF_POINT
          }, _this.props.renderBanner(menu.banner)));
        } // If we are in the empty 3rd column and there is a banner, then render the banner


        if (columnIndex === 2) {
          return /*#__PURE__*/React.createElement("div", {
            key: columnIndex,
            className: "menu-items__group"
          }, menu.banner && /*#__PURE__*/React.createElement(MediaQuery, {
            minWidth: DESKTOP_CUTOFF_POINT
          }, _this.props.renderBanner(menu.banner, columnIndex)));
        }
      }));
    };

    _this.renderMobilePane = function (analytics, location) {
      return /*#__PURE__*/React.createElement("div", {
        className: "menu-items__group menu-items__group--calculators"
      }, _this.props.navTreeData.mobilePane.items.map(function (menuItem) {
        return /*#__PURE__*/React.createElement(MenuItem, Object.assign({
          key: menuItem.id
        }, menuItem, {
          active: _this.state.activeMenuId === menuItem.id,
          onClick: function onClick() {
            return _this.handleMenuItemClick(menuItem, analytics, location);
          }
        }));
      }));
    };

    _this.renderNavigationBar = function (analytics, location) {
      return /*#__PURE__*/React.createElement("nav", {
        className: "site-header__nav",
        itemScope: true,
        itemType: "http://schema.org/SiteNavigationElement"
      }, /*#__PURE__*/React.createElement(HamburgerButton, {
        ref: function ref(el) {
          _this.hamburgerButton = el;
        },
        hamburgerButtonRef: true,
        navOpen: _this.state.isNavOpen,
        onClick: function onClick() {
          return _this.toggleNavOpen(analytics, location);
        }
      }), _this.props.renderBrandButton(!_this.state.isSearchOpen), _this.renderMainMenu(!_this.state.isSearchOpen, analytics, location));
    };

    _this.hamburgerButton = /*#__PURE__*/React.createRef();
    _this.topMenuItems = /*#__PURE__*/React.createRef();
    return _this;
  }

  var _proto = BaseHeader.prototype;

  _proto.componentDidMount = function componentDidMount() {
    // check and set login modal data
    var loginModalData = getLoginModalData(this.props.loginModalsData);

    if (loginModalData) {
      this.setState({
        showLoginModal: true,
        loginModalData: loginModalData
      });
    } // bind events


    document.addEventListener('keydown', this.handleKeyDown, false);
    document.addEventListener('mousedown', this.handleClick, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // unbind events
    document.removeEventListener('keydown', this.handleKeyDown, false);
    document.removeEventListener('mousedown', this.handleClick, false);
  }
  /*
   * Handle key down
   */
  ;

  _proto.render = function render() {
    var _this2 = this;

    var analytics = {};
    return /*#__PURE__*/React.createElement(AnalyticsLocationProvider, {
      location: ANALYTICS.LOCATION.HEADER
    }, /*#__PURE__*/React.createElement(AnalyticsContext.Consumer, null, function (_ref) {
      var analytics = _ref[0];
      return /*#__PURE__*/React.createElement(AnalyticsLocationConsumer, null, function (location) {
        return /*#__PURE__*/React.createElement("header", {
          className: classnames('site-header', 'site-base-header', {
            'active-header': _this2.state.isNavBackgroundVisible
          }),
          "data-sticky-navigation-offset": true
        }, /*#__PURE__*/React.createElement("div", {
          className: "site-header__inner"
        }, /*#__PURE__*/React.createElement("div", {
          className: "site-header__nav-wrap no-padding-mob"
        }, _this2.renderNavigationBar(analytics, location), /*#__PURE__*/React.createElement(SearchForm, {
          analytics: analytics,
          active: _this2.state.isSearchOpen,
          animateClose: _this2.state.animateClose,
          onRequestClose: function onRequestClose() {
            _this2.closeSearchForm();

            trackEvent(analytics, {
              category: 'search',
              action: 'interaction',
              label: 'close',
              location: location
            });
          },
          searchFormData: _this2.props.searchFormData
        }), /*#__PURE__*/React.createElement(SearchButton, {
          visible: !_this2.state.isSearchOpen,
          onClick: function onClick() {
            _this2.toggleSearchIsActive();

            trackEvent(analytics, {
              category: 'search',
              action: 'interaction',
              label: 'open',
              location: location
            });
          }
        }), /*#__PURE__*/React.createElement(LogonButton, {
          ref: function ref(el) {
            _this2.logonButtonElement = el;
          },
          active: _this2.state.isLoginOpen,
          mobileVisible: !_this2.state.isSearchOpen,
          onClick: function onClick() {
            return _this2.toggleLoginIsActive(analytics, location);
          },
          label: _this2.props.logonButtonLabel
        }, /*#__PURE__*/React.createElement(LoginModal, {
          isOpen: _this2.state.showLoginModal && !_this2.state.isLoginOpen,
          data: _this2.state.loginModalData,
          onRequestClose: _this2.closeLoginModal,
          renderLoginModalImage: _this2.props.renderLoginModalImage
        })), /*#__PURE__*/React.createElement(LoginForm, {
          analytics: analytics,
          loginForm: _this2.props.loginFormData,
          cardTypes: _this2.props.cardTypesData,
          isOpen: _this2.state.isLoginOpen,
          onRequestClose: _this2.closeLoginForm,
          openElement: _this2.logonButtonElement
        }))));
      });
    }));
  };

  return BaseHeader;
}(React.Component);

export default BaseHeader;